"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "games-overview",
    class: "games-overview-container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_game_overview = (0, vue_1.resolveComponent)("game-overview");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h1", null, [
            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.constants.APP_NAME) + " — Games Overview", 1)
        ])), [
            [_directive_i18n]
        ]),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("p", null, [...(_cache[0] || (_cache[0] = [
                (0, vue_1.createTextVNode)("The following games are available on this server:", -1)
            ]))])), [
            [_directive_i18n]
        ]),
        (0, vue_1.createElementVNode)("table", null, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.entries, (entry) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_game_overview, {
                    key: entry.id,
                    id: entry.id,
                    game: entry.game,
                    status: entry.status
                }, null, 8, ["id", "game", "status"]));
            }), 128))
        ])
    ]));
}
